import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import confirm from 'utils/confirm';
import {unsavedMessage} from 'utils/const';
import noop from 'lodash/noop';
import RuleTagEditor from 'components/triggers/rule-tags-dialog/RuleTagEditor';
import {Set, List} from 'immutable';
import TriggerRuleActions from 'actions/triggers/TriggerRuleActions';
import ToastActions from '@store/toast/ToastActions';
import {ClosableDialogTitle} from '@components/dialog/closable-title/ClosableDialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TriggerRuleInfo from 'records/TriggerRuleInfo';

interface RuleTagsDialogProps {
  rule: TriggerRuleInfo;
  defaultTags: List<string>;
  onRequestClose: () => void;
}

interface RuleTagsDialogState {
  tags: Set<string>;
  submitting: boolean;
}

export class RuleTagsDialog extends React.PureComponent<RuleTagsDialogProps, RuleTagsDialogState> {
  constructor(props) {
    super(props);

    this.onRequestClose = this.onRequestClose.bind(this);
    this.onSave = this.onSave.bind(this);

    this.state = {
      tags: props.rule.tags.map(t => t.name).toSet(),
      submitting: false,
    };
  }

  onRequestClose() {
    const {onRequestClose, rule} = this.props;
    const ruleSet = rule.tags.map(t => t.name).toSet();
    if (this.state.tags.equals(ruleSet)) {
      onRequestClose();
    } else {
      confirm(unsavedMessage).then(onRequestClose, noop);
    }
  }

  async onSave() {
    if (this.state.submitting) return;

    const {tags} = this.state;
    const {rule} = this.props;

    try {
      this.setState({submitting: true});
      await TriggerRuleActions.updateTriggerRuleTags(rule.id, tags.toJS());
      ToastActions.addToast({
        message: 'Trigger Tags saved successfully!',
      });
      this.props.onRequestClose();
    } catch (e) {
      ToastActions.addToast({
        type: 'error',
        message: 'There was an error saving the trigger tags.',
      });
    } finally {
      this.setState({submitting: false});
    }
  }

  render() {
    const {tags, submitting} = this.state;
    const {defaultTags} = this.props;

    return (
      <Dialog open={true} onClose={this.onRequestClose}>
        <ClosableDialogTitle onClose={this.onRequestClose}>Edit Tags</ClosableDialogTitle>
        <DialogContent>
          <RuleTagEditor
            tags={tags}
            defaultTags={defaultTags}
            onChange={tags => this.setState({tags: Set(tags)})}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={this.onRequestClose}>
            Cancel
          </Button>
          <Button
            disabled={submitting}
            variant="contained"
            color="primary"
            className="ev-button"
            onClick={this.onSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
